import { SetObjectDataPropertyHelperBase } from './SetObjectDataPropertyHelperBase';
export class SetDataPropertyObjectPropertyHelper extends SetObjectDataPropertyHelperBase {
    getObject(sb) {
        return sb.helpers.getPropertyObject;
    }
}

//# sourceMappingURL=SetDataPropertyObjectPropertyHelper.js.map
